import { render, staticRenderFns } from "./SimpleTumbler.vue?vue&type=template&id=c8f57d72"
import script from "./SimpleTumbler.vue?vue&type=script&lang=js"
export * from "./SimpleTumbler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports